import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";;
import { SnackBarService } from '../../service/snack.bar.service';

export interface DialogData {
  name: string,
  email: string,
  phone: string
}

@Component({
  selector: 'prospect-dialog',
  templateUrl: 'prospect-dialog.html',
})
export class PropspectDialog implements OnInit {
  title: string;
  result: any;
  isCompany: boolean = false;

  constructor(
    private snackBarService: SnackBarService,
    public dialogRef: MatDialogRef<PropspectDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  ngOnInit() {
  }
}
